import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/management.css";
import "./styles/website.css";
import "./styles/recital.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "semantic-ui-css/semantic.min.css";
import { AuthProvider } from "./contexts/AuthContext";
import { LoadingProvider } from "./contexts/LoadingContext";
import { installSessionGuard } from "./utils/sessionGuard";

// 管理APIが 401（セッション切れ）を返したら自動で再ログインへ誘導する。
// フロントの「ログイン中」フラグとバックエンドの実セッションのズレを自己修復する。
installSessionGuard();

// クリックデモ（REACT_APP_DEMO=1 のビルドのみ）。バックエンド不要でUIを触ってもらう用途。
// 本番ビルド（フラグ未設定）では読み込まれず、通常挙動に影響しない。
if (process.env.REACT_APP_DEMO === "1") {
  // eslint-disable-next-line global-require
  require("./demo/installDemo").install();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <LoadingProvider>
        <App />
      </LoadingProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
